<template>
  <div class="content-wrapper" :data-ref="REFS.CONTENT_WRAPPER">
    <slot />
  </div>
</template>

<script>
import { REFS } from '@/utils/enums/external-refs'

import scss from '@/utils/scss'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'

export default {
  name: 'ALayoutContentContainer',
  mixins: [hydrationHelpers],
  data() {
    return {
      REFS
    }
  },
  computed: {
    contentStyle() {
      const contentWidth = 1460
      const largeBannerWidth = 160
      const smallBannerWidth = 120
      const spaceForWidgets = 50
      const desktopPadding = 58 * 2
      const mobilePadding = 15

      if (this.$_hydrationHelpers_windowWidth > scss.breakpoints.desktopLg) {
        return {
          maxWidth: `${Math.min(
            this.$_hydrationHelpers_windowWidth -
              2 * largeBannerWidth -
              2 * spaceForWidgets,
            contentWidth
          )}px`
        }
      } else if (
        this.$_hydrationHelpers_windowWidth > scss.breakpoints.tablet
      ) {
        return {
          maxWidth: `${Math.min(
            this.$_hydrationHelpers_windowWidth -
              2 * smallBannerWidth -
              2 * spaceForWidgets,
            contentWidth
          )}px`
        }
      } else if (
        this.$_hydrationHelpers_windowWidth > scss.breakpoints.mobile
      ) {
        const maxContentWidth = `${contentWidth}px`
        return {
          maxWidth: this.$_hydrationHelpers_windowWidth
            ? `${this.$_hydrationHelpers_windowWidth - desktopPadding}px`
            : maxContentWidth
        }
      } else {
        const maxContentWidth = `${contentWidth}px`
        return {
          maxWidth: this.$_hydrationHelpers_windowWidth
            ? `${this.$_hydrationHelpers_windowWidth - mobilePadding}px`
            : maxContentWidth
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$border-size-desktop-full-hd: 1px;

.content-wrapper {
  max-width: $desktop-above-full-hd-container;
  border: none;
  position: relative;
  min-width: 320px;
  margin: 0 auto;
  padding: $padding-y-desktop-full-hd $padding-x-desktop-full-hd 0;
  height: 100%;
  background: #fff;

  overflow-x: hidden;

  @media (min-width: #{$desktop-above-full-hd-container + 1}) {
    border: $border-size-desktop-full-hd solid $c--gray-light;
  }

  @include desktop-sm {
    padding: $padding-y-desktop-sm $padding-x-desktop-sm 0;
    border: none;
  }

  @include mobile {
    padding: 20px $padding-x-mobile 0;
  }
}
</style>
